module.exports = __webpack_public_path__ + "img/Lactuca_sativa.a86e1d4e.jpg";